export const dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
export const dateCreditCard = [/\d/, /\d/, '/', /\d/, /\d/];
